
import ImageHeader from '@/components/core/ImageHeader';
import tableLoading from '@/components/tableLoading';
import RestaurantCard from "@/components/RestaurantCard";
import NoContent from '@/components/customer-content/NoContent'
export default {
  scrollToTop: true,
  components: {
    ImageHeader,
    tableLoading,
    RestaurantCard,
    NoContent
  },
  data() {
    return {
      listingLoading: true,
      citySlug: null,
      cityDetails: null,
      restaurantsDetails: null,
    }
  },
  async validate({
    params,
    store
  }) {
    // await operations
    if (params.city != (null || "")) {
      this.citySlug = params.city;
      return true // if the params are valid
    } else {
      return false // will stop Nuxt.js to render the route and display the error page
    }
  },
  created() {
    this.citySlug = this.$route.params.city;
  },
  mounted() {
    this.getCityDetails();
    this.getRestaurantsInCity();
  },
  methods: {
    async getCityDetails() {
      this.cityDetails = await fetch(this.$config.fetchUrl + '/api/cities/app/' + this.citySlug).then(res => res
        .text());
      this.cityDetails = this.getCryptKey(this.cityDetails);
    },
    async getRestaurantsInCity() {
      this.restaurantsDetails = await fetch(this.$config.fetchUrl + '/api/posts/app/getRestaurantsInCity/' + this.citySlug).then(res => res
        .text());
      this.restaurantsDetails = this.getCryptKey(this.restaurantsDetails);
      this.restaurantsDetails.sort((x, y) => Number(y.featured) - Number(x.featured));
      this.listingLoading = false;
    },
    activitiesImage(image) {
      if (image.length > 0) {
        return image[0];
      } else {
        return '';
      }
    },
  }
}
